<div class="wrapper">
  <a mat-button class="page-back" routerLink="/schools" aria-label="Back to schools">
    <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
    <span>Back to schools</span>
  </a>

  <div class="title-bar title-bar--responsive">
    <div class="title-bar__heading">
      <h1>Default content</h1>
    </div>
  </div>
  <p>This copy is applied when an admin creates a school. Editing it does not change schools that already exist.</p>

  <div class="status-message" aria-live="polite" role="status">
    @if (statusMessage) {
      <span>{{ statusMessage }}</span>
    }
  </div>
  @if (errorMessage) {
    <p class="error-message" role="alert">{{ errorMessage }}</p>
  }

  @if (state !== 'loading') {
    <form [formGroup]="form" (ngSubmit)="save()">
      <section class="content-block">
        <h2>Welcome</h2>
        <quill-editor appQuillA11y="Default welcome introduction" [modules]="modules" theme="snow" formControlName="welcomeIntro"></quill-editor>
      </section>
      <section class="content-block">
        <h2>Welcome notes</h2>
        <quill-editor appQuillA11y="Default welcome notes" [modules]="modules" theme="snow" formControlName="welcomeDisclaimer"></quill-editor>
      </section>
      <section class="content-block">
        <h2>Next steps</h2>
        <quill-editor appQuillA11y="Default next steps" [modules]="modules" theme="snow" formControlName="nextSteps"></quill-editor>
      </section>
      <section class="content-block">
        <h2>School question header</h2>
        <quill-editor appQuillA11y="Default school question header" [modules]="modules" theme="snow" formControlName="schoolQuestionHeader"></quill-editor>
      </section>
      <div class="page-actions">
        <button mat-raised-button color="primary" type="submit" [disabled]="state === 'saving'">
          {{ state === 'saving' ? 'Saving…' : 'Save default content' }}
        </button>
        <a mat-button routerLink="/schools">Cancel</a>
      </div>
    </form>
  } @else {
    <p role="status">Loading default content…</p>
  }
</div>
